import React from "react";
/* import { render } from "react-dom"; */
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { getStore } from "./store";

import "./assets/css/style.css";
import "./assets/css/dark-style.css";
import "./assets/css/transparent-style.css";
import "./assets/css/skin-modes.css";
import "./assets/css/icons.css";

import Login from "./components/Login/Login";
import DepartmentList from "./components/Department/List";
import DepartmentForm from "./components/Department/Form";
import CategoryList from "./components/Category/List";
import CategoryForm from "./components/Category/Form";
import UserList from "./components/User/List";
import UserForm from "./components/User/Form";
import UserRoleList from "./components/Userroles/List";
import UserRoleForm from "./components/Userroles/Form";
import EmployeeList from "./components/Employee/List";
import EmployeeForm from "./components/Employee/Form";
import BrandList from "./components/Brand/List";
import BrandForm from "./components/Brand/Form";
import ProductsList from "./components/Products/List";
import ProductsForm from "./components/Products/Form";
import ProductsPurchase from "./components/Products/Purchase";
import CustomerList from "./components/Customer/List";
import CustomerForm from "./components/Customer/Form";
import ShiptoList from "./components/Shipto/List";
import ShiptoForm from "./components/Shipto/Form";

import VendorList from "./components/Vendor/List";
import VendorForm from "./components/Vendor/Form";
import SaleList from "./components/Sale/List";
import SaleForm from "./components/Sale/Form";
import SaleModifyForm from "./components/Sale/ModifyForm";

import Invoice from "./components/Sale/Invoice";
import ProformaInvoice from "./components/Sale/ProformaInvoice";
import Deliverychallan from "./components/Sale/Deliverychallan";
import ProductReport from "./components/Report/Product";
import CustomerReport from "./components/Report/Customer";
import PaymentTrackingReport from "./components/Report/PaymentTracking";
import MonthWiseSales from "./components/Report/MonthWiseSales";
import SalesReport from "./components/Report/Sales";
import SaleAssignEngineerReport from "./components/Report/SaleAssignEngineer";
import PurchaseItemReport from "./components/Report/PurchaseItem";
import PurchaseReport from "./components/Report/Purchase";
import gstReport from "./components/Report/gstReport";
import StatisticsReport from "./components/Report/Statistics";
import SaleStatisticsReport from "./components/Report/SaleStatistics";
import PurchaseStatisticsReport from "./components/Report/PurchaseStatistics";
import PurchaseorderReport from "./components/Report/Purchaseorder";


import Dashboard from "./components/Dashboard/List";
import AttendanceList from "./components/Attendance/List";
import JobsList from "./components/Jobs/List";
import ChangePassword from "./components/ChangePassword/Form";

import Purchase from "./components/Purchase/List";

import PurchaseorderList from "./components/Purchaseorder/List";
import PurchaseorderForm from "./components/Purchaseorder/Form";
import PurchaseorderInvoice from "./components/Purchaseorder/Invoice";

import Logout from "./components/Helpers/Logout";
import Refpage from "./components/Layout/Refpage";
import Page404 from "./Page404";

const store = getStore();
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <Router>
      <Switch>
        <Route exact path="/department" component={DepartmentList} />
        <Route exact path="/department/add" component={DepartmentForm} />
        <Route exact path="/department/edit" component={DepartmentForm} />
        <Route exact path="/category" component={CategoryList} />
        <Route exact path="/category/add" component={CategoryForm} />
        <Route exact path="/category/edit" component={CategoryForm} />
        <Route exact path="/users" component={UserList} />
        <Route exact path="/users/add" component={UserForm} />
        <Route exact path="/users/edit" component={UserForm} />
        <Route exact path="/userroles" component={UserRoleList} />
        <Route exact path="/userroles/add" component={UserRoleForm} />
        <Route exact path="/userroles/edit" component={UserRoleForm} />
        <Route exact path="/employee" component={EmployeeList} />
        <Route exact path="/employee/add" component={EmployeeForm} />
        <Route exact path="/employee/edit" component={EmployeeForm} />
        <Route exact path="/brand" component={BrandList} />
        <Route exact path="/brand/add" component={BrandForm} />
        <Route exact path="/brand/edit" component={BrandForm} />
        <Route exact path="/products" component={ProductsList} />
        <Route exact path="/products/add" component={ProductsForm} />
        <Route exact path="/products/edit" component={ProductsForm} />
        <Route exact path="/products/purchase" component={ProductsPurchase} />
        <Route exact path="/customer" component={CustomerList} />
        <Route exact path="/customer/add" component={CustomerForm} />
        <Route exact path="/customer/edit" component={CustomerForm} />
        <Route exact path="/shipto" component={ShiptoList} />
        <Route exact path="/shipto/add" component={ShiptoForm} />
        <Route exact path="/shipto/edit" component={ShiptoForm} />        
        <Route exact path="/vendors" component={VendorList} />
        <Route exact path="/vendors/add" component={VendorForm} />
        <Route exact path="/vendors/edit" component={VendorForm} />
        <Route exact path="/sale" component={SaleList} />
        <Route exact path="/sale/create" component={SaleForm} />
        <Route exact path="/sale/renewal/:saleID" component={SaleForm} />
        <Route exact path="/sale/modify/:saleID" component={SaleModifyForm} />
        <Route exact path="/sale/convertsale/:saleID" component={SaleForm} />
        <Route exact path="/sale/invoice/:saleID/history" component={Invoice} />
        <Route exact path="/sale/invoice/:saleID" component={Invoice} />
        <Route exact path="/sale/proforma-invoice/:saleID" component={ProformaInvoice} />
        
        <Route exact path="/purchase" component={Purchase} />
        <Route exact path="/purchaseorder" component={PurchaseorderList} />
        <Route exact path="/purchaseorder/create" component={PurchaseorderForm} />
        <Route exact path="/purchaseorder/invoice/:poID" component={PurchaseorderInvoice} />        
        
        <Route
          exact
          path="/sale/deliverychallan/:saleID"
          component={Deliverychallan}
        />

        <Route exact path="/report/product" component={ProductReport} />
        <Route exact path="/report/customer" component={CustomerReport} />
        <Route
          exact
          path="/report/payment-tracking"
          component={PaymentTrackingReport}
        />
        <Route exact path="/report/sales" component={MonthWiseSales} />
        <Route exact path="/report/sales/:monthYear/:customerID" component={SalesReport} />
        <Route exact path="/report/sales/:monthYear/" component={SalesReport} />
        <Route
          exact
          path="/report/engineer"
          component={SaleAssignEngineerReport}
        />
        <Route exact path="/report/purchase/item" component={PurchaseItemReport} />
        <Route exact path="/report/purchase" component={PurchaseReport} />
        <Route exact path="/report/purchaseorder" component={PurchaseorderReport} /> 
        
        <Route exact path="/report/statistics/sale/:reportType" component={SaleStatisticsReport} />
        <Route exact path="/report/statistics/purchase/:reportType" component={PurchaseStatisticsReport} />
                  
        <Route exact path="/report/statistics" component={StatisticsReport} />        
        
        <Route exact path="/report/gstreport" component={gstReport} />

        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/attendance" component={AttendanceList} />
        <Route exact path="/jobs" component={JobsList} />
        <Route exact path="/changepassword" component={ChangePassword} />

        <Route exact path="/" component={Login} />
        <Route path={"/refpage/:slugtext"} component={Refpage} />
        <Route path={"/logout"} component={Logout} />
        <Route component={Page404} />
      </Switch>
    </Router>
  </Provider>
);
